import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { first } from 'rxjs/operators'
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from "@ngx-translate/core";
import { lang_cerv3 } from 'app/idiomas/i18n/cerV3/cerv3.lang';
import { ActivatedRoute } from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import * as $ from 'jquery';
import * as bdDemo from '../bdDemo';
import * as catalogos from '../catalogos';

import { ModalComponent } from "./modal/modal.component";
import { DetalleComponent } from "./detalle/detalle.component";

import { PreguntasService } from "../../preguntas.service";
import { SurveyProductService } from "app/main/wizard-cgo/survey-product/survey-product.service";

type AOA = any[][];

import { DATOS_API } from 'app/auth/auth.datos';
import { fuseAnimations } from '@fuse/animations';

import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'preguntas',
  templateUrl: './preguntas.component.html',
  styleUrls: ['./preguntas.component.scss'],
  animations   : fuseAnimations
})
export class PreguntasComponent implements OnInit {

  comunicacionTraducciones: any;
  @Input() actualizaCuestionarioTrad: Observable<any>;
  comunicacionStatusCompletado: any;
  @Input() statusPaso: Observable<any>;

  @Output() guardandoTemplate: EventEmitter<any> = new EventEmitter();
  @Output() idiomasGuardados: EventEmitter<any> = new EventEmitter();
  @Output() seccionesGuardadas: EventEmitter<any> = new EventEmitter();

  urlAssets = DATOS_API.urlAssets;

  cargando = true;

  pasoCompleto: boolean;

  productoCertificar: any;
  idiomas: any;
  catalogoDemo: any[] = [];
  seccionesDemo: any[] = [];
  idsUniqueOcupadas: any[] = [];
  catalogoIdiomasSurvey: any;
  catalogoRespReactivos: any;
  catalogoRespForall: any;
  catalogoDemograficos: any;
  lorem = bdDemo.lorem.split(" ");
  nuevasRestantes = 0;  //contador de preguntas nuevas (fuera del template original) restantes
  tipoEspecial = [
    { nombre: 'Pregunta normal', tipo: 1 },
    { nombre: 'Pregunta especial', tipo: 2 }
  ];
  listasPreguntas: any[] = [];
  textClaveMostrar:any;

  seccionesOriginal: any[] = [];
  typeCustomBooleanTrue=true;
  typeCustomBooleanFalse=false;

  configTemplate = {
    nuevasPreguntas: true,
    preguntasMC: true,
    movibles: true,
    editables: true,
    eliminables: true,
    audios: false,
    nuevasSecciones: true,
    secMovibles: true,
    secEditables: true,
    secEliminables: true,
    secNombresObligatorios: true,
    audiosGlobal: false,
    secEspeciales: false,
    limites: {
      demograficos: 5,
      abiertas: 5,
      forall: 5,
      adicionales: 5,
      preguntasMaximas: 5
    }
  };

  modoEmpresa: boolean;
  debugModos: boolean = true; //CAMBIAR A FALSE CUANDO SE HAGAN PRUEBAS Y NO SE DESEE GUARDAR CAMBIOS
  configItbm: boolean;
  templateGuardado = true;

  idiomaNative = 'es';

  cargandoFilePreg: boolean;

  tiposPreguntas = [
    { tipoInterfaz: 2, tipoSeccion: 1, tipoPregEncuesta: [1,2], nombre: 'NPS' },
    { tipoInterfaz: 1, tipoSeccion: 2, tipoPregEncuesta: [3], nombre: 'reactivos' },
    { tipoInterfaz: 2, tipoSeccion: 3, tipoPregEncuesta: [1,2], nombre: 'control' },
    { tipoInterfaz: 2, tipoSeccion: 4, tipoPregEncuesta: [2,4,6], nombre: 'demograficos' },
    { tipoInterfaz: 2, tipoSeccion: 5, tipoPregEncuesta: [2], nombre: 'abiertas' },
    { tipoInterfaz: 3, tipoSeccion: 6, tipoPregEncuesta: [5], nombre: 'forall' },
    { tipoInterfaz: 2, tipoSeccion: 7, tipoPregEncuesta: [2,4,6], nombre: 'adicionales' },
  ];
  // tipoPregSel: number;
  tipoPregSel = 3;  //indice del arreglo tiposPreguntas

  jsonCuestionario: any;
  tipoSeccionActualizar:any;
  nameUserAdmin:any="";
  userData:any;
  validationUser:boolean = true;
  accionText:string="";

  puedeGuardarCambios = false;
  infoVoces: any;
  institutoEmpresa=localStorage.getItem('instituto_id');

  constructor(
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private preguntasService: PreguntasService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    public sanitizer: DomSanitizer,
    private surveyProductService: SurveyProductService
  ) {
    lang_cerv3.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    if(localStorage.getItem("userBypass")){
      this.configItbm = true;
      this.modoEmpresa = false;

      this.userData=JSON.parse(localStorage.getItem('userBypass'));
      if(this.userData.level==3 || this.userData.level==2){
        // this.validationUser=true;
        this.nameUserAdmin=this.userData.user;
      }
      else{
        // this.validationUser=false;
        this.nameUserAdmin="";
      }


    }
    else{
      this.configItbm = false;
      this.modoEmpresa = true;
    }
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(params => {
      this.tipoPregSel = this.tiposPreguntas.findIndex(item => item.tipoSeccion == params.tipoSeccion);
    });
    // this.getCatIdiomasSurvey();
    // this.getCertificar();
    this.surveyProductService.enviaDatosASurvProd({ recuperaInformacion: true });
    this.recibeDatosSP();

    // this.actualizaListasPreguntas();
    this.comunicacionTraducciones = this.actualizaCuestionarioTrad.subscribe( (datos:any) => {
      if(datos != null){
        console.log("se envio desde traducciones:",datos);
        if(datos.status == true){
          this.actualizaCuestionario(null, true, null, datos.getCatalogo);
        }
      }
    });
    this.comunicacionStatusCompletado = this.statusPaso.subscribe( (datos:any) => {
      if(datos != null){
        this.pasoCompleto = datos;
      }
    });
  }

  recibeDatosSP(){
    this.surveyProductService.recibidosSurvProd.pipe(first()).subscribe((datos:any) => {
      console.log("---------------------------DATOS RECIBIDOS :V ----------------------------");
      console.log(datos);
      console.log("datosOriginales:",JSON.parse(JSON.stringify(datos)));
      if(datos.recuperaInformacion == true){
        this.getCertificar(datos);
      }
      if(datos.actualizarProducto == true){
        this.getSeccionesCuestionario(datos);
      }
      if(datos.actualizarCatalogo == true){
        this.getCatalogoMaestro(datos.catalogo);
      }
    });
  }

  // getCertificar(){
  //   this.preguntasService.getProdCertAct().subscribe((data:any) => {
  //     let prodsCertificar:any[] = data.productosCertificar;
  //     let indiceProducto = prodsCertificar.findIndex(item => item.fechaCertificar == parseInt(localStorage.getItem('fechaProducto')) && item.idCertificar == localStorage.getItem('productoID'));
  //     if(indiceProducto != -1){
  //       this.productoCertificar = prodsCertificar[indiceProducto];
  //       this.getSeccionesCuestionario();
  //       this.obtieneIdiomasGuardados();
  //     }
  //   }, error  => {
  //     console.log("error al recuperar certificar vigente");
  //   });
  // }
  getCertificar(datosProducto: any){
    this.productoCertificar = datosProducto.productoCertificar;
    this.getSeccionesCuestionario(datosProducto);
    this.obtieneIdiomasGuardados(datosProducto);
  }
  // obtieneIdiomasGuardados(){
  //   let datos:any= {productoId:this.productoCertificar.idCertificar};
  //   this.preguntasService.getIdiomasProd(datos).subscribe( (data: any) => {
  //     this.idiomas = data.idiomasMostrar;
  //     this.idiomasGuardados.emit(this.idiomas);
  //     let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == "1");
  //     this.idiomaNative = this.idiomas[indiceIdiomaNativo].nombreIdioma;
  //     this.getCatRespuestasReactivos();
  //     this.getCatDatosForAll();
  //     this.getCatDemograficos();
  //   });
  // }
  obtieneIdiomasGuardados(datosProducto: any){
    this.idiomas = datosProducto.idiomas;
    this.idiomasGuardados.emit(this.idiomas);
    let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == "1");
    this.idiomaNative = this.idiomas[indiceIdiomaNativo].nombreIdioma;
    this.getCatRespuestasReactivos(datosProducto.catalogoRespReactivos);
    this.getCatDatosForAll(datosProducto.catalogoRespForall);
    this.getCatDemograficos(datosProducto.catalogoDemograficos);
    this.getCatIdiomasSurvey(datosProducto.catalogoIdiomasSurvey);
  }
  getSeccionesCuestionario(datosProducto: any){
    let datos:any= this.productoCertificar.surveyProductId._id;
    // this.preguntasService.getSeccionesCuestionario(datos).subscribe((respuesta:any) => {
    //   console.log("getSeccCuestionario:",respuesta);
      // console.log(this.tiposPreguntas);
      // this.jsonCuestionario = respuesta.surveyproduct;
      this.jsonCuestionario = datosProducto.surveyProduct;
      let tipoSeccion = this.tiposPreguntas[this.tipoPregSel].tipoSeccion;
      // console.log(this.tipoPregSel);
      // console.log("Sección "+tipoSeccion);
      this.tipoSeccionActualizar=tipoSeccion;
      // console.log('++this.tipoSeccionActualizar++',this.tipoSeccionActualizar);

      this.seccionesDemo = [];
      this.jsonCuestionario.sections.forEach((seccion:any) => {
        if(seccion.typeSection == tipoSeccion){
          // seccion.pendientesMC = false;
          if(tipoSeccion == 6){
            seccion.pendientesForAll = false;
          }
          if(tipoSeccion == 1 || tipoSeccion == 3 || tipoSeccion == 4 || tipoSeccion == 7){
            seccion.pendientesOpciones = false;
          }
          this.seccionesDemo.push(seccion);
        }
      });

      this.setConfiguracionInicial();
      this.filtroIDUniqueOcupadas();
      this.buscaPendientesMC();
      this.buscaPendientesOpciones();
      this.buscaCambiosTemplate();
      this.buscaPreguntasNuevasTemplate();
      this.DEMO_colocaAudiosPregunta();
      if(datosProducto.catalogo){ //si llega el catalogo dentro de la info de surveyProduct se reemplaza
        this.getCatalogoMaestro(datosProducto.catalogo);
      }
      this.actualizaListasPreguntas();
      this.enviaSeccionesDemo();
      console.log("seccionesDemoTemplate:",this.seccionesDemo);
      this.puedeGuardarCambios = datosProducto.infoTemplate.base;
    // });
  }

  setConfiguracionInicial(){
    console.log('Configuracion this.jsonCuestionario.enableCustom',this.jsonCuestionario.enableCustom);

    this.configTemplate = {
      nuevasPreguntas: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].addNewQuestions : true,
      preguntasMC: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].addCatQuestions : true,
      movibles: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].moveQuestions : true,
      editables: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].editQuestions : true,
      eliminables: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].deleteQuestions : true,
      audios: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].enableAudio : false,
      nuevasSecciones: this.jsonCuestionario.addSections,
      secMovibles: this.jsonCuestionario.moveSections,
      secEditables: this.jsonCuestionario.editSections,
      secEliminables: this.jsonCuestionario.deleteSections,
      secNombresObligatorios: this.jsonCuestionario.nameSections,
      audiosGlobal: this.jsonCuestionario.enableAudio,
      secEspeciales: this.jsonCuestionario.enableCustom,
      limites: {
        demograficos: 5,
        abiertas: 5,
        forall: 5,
        adicionales: 5,
        preguntasMaximas: this.seccionesDemo[0] != undefined ? this.seccionesDemo[0].maxQuestions : 10
      }
    };
  }

  filtroIDUniqueOcupadas(){
    this.idsUniqueOcupadas = [];
    this.jsonCuestionario.sections.forEach((seccion, i) => {
      if(seccion.typeSection == this.tiposPreguntas[this.tipoPregSel].tipoSeccion){
        seccion.questions.forEach(pregunta => {
          if(pregunta.idUnique < 99999){
            this.idsUniqueOcupadas.push(pregunta.idUnique);
          }
        });
      }
    });
    console.log("idsUniqueOcupadas:",this.idsUniqueOcupadas);
  }

  // getCatalogoMaestro(){
  //   this.preguntasService.getCatalogo(localStorage.getItem('instituto_id'), this.tiposPreguntas[this.tipoPregSel].tipoSeccion.toString()).subscribe((respuesta:any) => {
  //     console.log("getCatalogo:",respuesta);
  //     respuesta.questions.forEach((pregunta:any) => {
  //       if(this.tiposPreguntas[this.tipoPregSel].tipoPregEncuesta.includes(pregunta.answerType)){
  //         // if(!this.idsUniqueOcupadas.includes(pregunta.idUnique)){
  //         // if(this.tiposPreguntas[this.tipoPregSel].tipoSeccion == pregunta.typeSection){
  //           pregunta.ocupada = false;
  //           this.catalogoDemo.push(pregunta);
  //         // }
  //         // }
  //       }
  //     });
  //     console.log("catalogoObtenido:",this.catalogoDemo);
  //     this.cargando = false;
  //   });
  // }
  getCatalogoMaestro(datos:any){
    this.catalogoDemo = [];
    datos.forEach((pregunta:any) => {
      if(this.tiposPreguntas[this.tipoPregSel].tipoPregEncuesta.includes(pregunta.answerType)){
        // if(!this.idsUniqueOcupadas.includes(pregunta.idUnique)){
        if(this.tiposPreguntas[this.tipoPregSel].tipoSeccion == pregunta.typeSection){
          pregunta.ocupada = false;
          this.catalogoDemo.push(pregunta);
        }
        // }
      }
    });
    console.log("catalogoObtenido:",this.catalogoDemo);
    this.cargando = false;
  }

  // getCatIdiomasSurvey(){
  //   this.preguntasService.getCatIdiomasSurvey().subscribe((respuesta:any) => {
  //     // console.log("getCatIdiomasSurvey",respuesta);
  //     this.catalogoIdiomasSurvey = respuesta.languages;
  //   });
  // }
  getCatIdiomasSurvey(datos: any){
    this.catalogoIdiomasSurvey = datos;
  }
  // getCatRespuestasReactivos(){
  //   this.preguntasService.getCatRespuestasReactivos().subscribe((respuesta:any) => {
  //     console.log("getCatRespuestasReactivos",respuesta);
  //     this.catalogoRespReactivos = respuesta.answers;
  //     let idiomasActuales: any[] = [];
  //     this.idiomas.forEach(idioma => {
  //       if(idioma.tipoIdioma == 0 || idioma.tipoIdioma == 1){
  //         idiomasActuales.push(idioma.nombreIdioma);
  //       }
  //     });
  //     this.catalogoRespReactivos.forEach(respReactivo => {
  //       let listaIdiomasResp: any[] = [];
  //       respReactivo.answerLanguage.forEach(idiomaResp => {
  //         // if(idiomasActuales.includes(idiomaResp.lang)){
  //           listaIdiomasResp.push(idiomaResp);
  //         // }
  //       });
  //       respReactivo.answerLanguage = listaIdiomasResp;
  //     });
  //     console.log("catalogoRespReactivosFinal:",this.catalogoRespReactivos);
  //
  //   });
  // }
  getCatRespuestasReactivos(datos: any){
    this.catalogoRespReactivos = datos;
    console.log("catalogoRespReactivosFinal:",this.catalogoRespReactivos);
  }
  // getCatDatosForAll(){
  //   this.preguntasService.getCatDatosForAll().subscribe((respuesta:any) => {
  //     console.log("getCatForall",respuesta);
  //     this.catalogoRespForall = respuesta.questions;
  //     console.log("catalogoRespForallFinal:",this.catalogoRespForall);
  //
  //   });
  // }
  getCatDatosForAll(datos: any){
    this.catalogoRespForall = datos;
    console.log("catalogoRespForallFinal:",this.catalogoRespForall);
  }
  // getCatDemograficos(){
  //   this.preguntasService.getCatDemograficos().subscribe((respuesta:any) => {
  //     console.log("getCatDemograficos",respuesta);
  //     this.catalogoDemograficos = respuesta.demographics;
  //   });
  // }
  getCatDemograficos(datos: any){
    this.catalogoDemograficos = datos;
    console.log("catalogoDemograficos:",this.catalogoDemograficos);
  }

  actualizaListasPreguntas(){
    this.listasPreguntas = [];
    this.seccionesDemo.forEach((element, i) => {
      this.listasPreguntas.push("lista" + i);
    });
    this.buscaPendientesMC();
    this.buscaPendientesOpciones();
  }
  actualizaOrdenSeccionesTemplate(){
    let indiceInicial: number;
    let seccionesDepuradas: any[] = [];
    this.jsonCuestionario.sections.forEach((seccion, i) => {
      if(seccion.typeSection == this.tiposPreguntas[this.tipoPregSel].tipoSeccion){
        if(indiceInicial == null){
          indiceInicial = i;
        }
      }
      else{
        seccionesDepuradas.push(seccion);
      }
    });
    this.jsonCuestionario.sections = seccionesDepuradas;
    this.jsonCuestionario.sections.splice(indiceInicial, 0, ...this.seccionesDemo);
    this.jsonCuestionario.sections.forEach((seccion, i) => {
      seccion.orderSection = (i+1);
    });
    // this.jsonCuestionario.sections.sort( (a,b) => { if(a.typeSection > b.typeSection){ return 1; } else{ return -1; } });
  }

  buscaPendientesMC(){
    let BreakException = {};
    try {
      this.seccionesDemo.forEach(seccion => {
        seccion.pendientesMC = false;
        seccion.questions.forEach(pregunta => {
          if(pregunta.typeAdd != 0 && pregunta.typeAdd != 1){
            seccion.pendientesMC = true;
            throw BreakException;
          }
        });
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
  }
  buscaPendientesOpciones(){
    if(this.tiposPreguntas[this.tipoPregSel].tipoInterfaz == 2){
      let BreakException = {};
      try {
        this.seccionesDemo.forEach(seccion => {
          seccion.questions.forEach(pregunta => {
            if(pregunta.answerType == 1 || pregunta.answerType == 4 || pregunta.answerType == 6){
              seccion.pendientesOpciones = false;
              if(pregunta.answers){
                if(pregunta.answers.length < 2){  // dos respuestas minimas para estos tipos de pregunta
                  seccion.pendientesOpciones = true;
                  throw BreakException;
                }
              }
              else{
                seccion.pendientesOpciones = true;
                throw BreakException;
              }
            }
          });
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
    }
  }
  buscaCambiosTemplate(){
    let BreakException = {};
    try {
      this.seccionesDemo.forEach(seccion => {
        seccion.questions.forEach(pregunta => {
          if(pregunta.typeAdd != 0){
            this.templateGuardado = false;
            throw BreakException;
          }
        });
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
  }
  buscaUltimaIdUnique99999(){
    let arregloIds: any[] = [99999];
    this.jsonCuestionario.sections.forEach((seccion:any) => {
      seccion.questions.forEach(pregunta => {
        if(pregunta.idUnique > 99999){
          arregloIds.push(pregunta.idUnique);
        }
      });
    });
    arregloIds.sort((a,b)=>a-b);
    console.log("ultimoIdUnique:",arregloIds[arregloIds.length - 1]);
    return arregloIds[arregloIds.length - 1] + 1;
  }
  buscaPreguntasNuevasTemplate(){
    this.nuevasRestantes = this.configTemplate.limites.preguntasMaximas;
    this.seccionesDemo.forEach(seccion => {
      seccion.questions.forEach(pregunta => {
        if(pregunta.typeAdd != 0){
          this.nuevasRestantes--;
        }
      });
    });
  }

  DEMO_colocaAudiosPregunta(){
    this.seccionesDemo.forEach(seccion => {
      seccion.questions.forEach(pregunta => {
        pregunta.questionLanguage.forEach(idioma => {
          // idioma.audio = false;
          // idioma.audioData = '';
          // idioma.audioUrl = '';
          if(idioma.audioUrl != undefined){
            if(idioma.audioUrl.length > 0){
              idioma.audio = true;
            }
          }
        });
      });
    });
  }

  DEMO_convierteAudioBlob(base64:string){
    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    const contentType = 'audio/mpeg';
    const b64Data = base64;

    const blob = b64toBlob(b64Data, contentType);
    const blobUrl = URL.createObjectURL(blob);
    // this.blobAudio = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    return blobUrl;
  }

  DEMO_agregarAudioPregunta(datosPregunta:any, tipo:string, datosPregSP:any){
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose: true,
      width: '60%',
      data: {
        opcion: 'nuevoAudio',
        tipo,
        idiomas: this.idiomas,
        datosPregunta,
        // pregCat: this.datos.pregCat,
        datosPregSP,
        recuperarPregCat: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        if(result.base64 != undefined){
          datosPregunta.audio = true;
          datosPregunta.audioData = '';
          datosPregunta.audioUrl = ''
          setTimeout(() => {
            datosPregunta.audioData = result.base64;
            datosPregunta.audioUrl = result.url
            this.actualizaCuestionario();
          });
        }
      }
    });
  }

  DEMO_reproducirAudioPregunta(datosPregunta:any){
    // const audio = new Audio(datosPregunta.audioUrl);
    // audio.play();
    datosPregunta.audioUrl = this.DEMO_convierteAudioBlob(datosPregunta.audioData);
  }

  DEMO_borrarAudioPregunta(datosPregunta:any){
    Swal.fire({
      icon: 'question',
      title: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.BORRAR'),
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.CANCELAR'),
      confirmButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.ACEPTAR'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        const codigo = Math.random().toString(36).substring(7);
        Swal.fire({
          title: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.CONFIRMAR_BORRAR') + '<font color="red">' + codigo + '</font>',
          icon: 'info',
          input:'text',
          showCancelButton: true,
          reverseButtons: true,
          cancelButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.CANCELAR'),
          confirmButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.ACEPTAR')
        }).then( (borrar) => {
          if (borrar.value == codigo) {
            datosPregunta.audio = false;
            datosPregunta.audioData = '';
            datosPregunta.audioUrl = '';
            this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.BORRADO_OK'), "OK");
          } else{
            if(!borrar.dismiss){
              Swal.fire({
                icon: 'error',
                title: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.CODIGO_MAL'),
                showConfirmButton: true,
                confirmButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.ACEPTAR')
              })
            }
          }
        });
      }
    });
  }

  recuperaConfigVoces(){
    this.surveyProductService.enviaDatosASurvProd({ recuperaConfigVoces: true });
    this.surveyProductService.recibidosSurvProd.pipe(first()).subscribe((datos:any) => {
      this.infoVoces = datos.infoVoces;
      console.log("this.infoVoces:",this.infoVoces);

    });
  }

  enviaSeccionesDemo(){
    this.seccionesGuardadas.emit({
      jsonCuestionario: this.jsonCuestionario,
      tipoSeccion: this.tiposPreguntas[this.tipoPregSel].tipoSeccion,
      seccionesDemo: this.seccionesDemo,
      configTemplate: this.configTemplate
    });
  }

  guardaCambiosTemplate(opcion:number){
    let datos: any = {saveAs: opcion};
    let surveyProductId:any;
    let titleNewPlantilla = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_MOD_GUA_CAM_TEMP');
    let textNombrePlantilla = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_MOD_GUA_CAM_TEMP');
    let btnCancelar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CAN_MOD_GUA_CAM_TEMP');
    let btnAgregar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_AGRE_MOD_GUA_CAM_TEMP');
    let returns = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.RETUR_MOD_GUA_CAM_TEMP');
    let titlePlantillaOriginal = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_MOD_GUA_CAM_TEMP2');
    let btnContinuar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CONTI_MOD_GUA_CAM_TEMP');
    switch (opcion) {
      case 1:   //nuevoTemplate
        Swal.fire({
          title: titleNewPlantilla,
          text: textNombrePlantilla,
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
reverseButtons: true,
          confirmButtonText: btnAgregar,
          cancelButtonText:  btnCancelar,
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          inputValidator: nombrePregunta => {
            // Si el valor es válido, debes regresar undefined. Si no, una cadena
            if (!nombrePregunta) {
                return returns;
            } else {
                return undefined;
            }
          }
        }).then((result) => {
          if (result.value) {
            datos.name = result.value;
            this.preguntasService.saveCambiosTemplate(this.productoCertificar.surveyProductId._id, datos).subscribe((respuesta:any) => {
              console.log("saveCambiosTemplate:",respuesta);
              let nuevoSurveyProduct = JSON.parse(JSON.stringify(respuesta.surveyproduct));
              console.log("nuevoSurveyProduct:",nuevoSurveyProduct);
              this.jsonCuestionario = {};
              this.jsonCuestionario = nuevoSurveyProduct;
              setTimeout(() => {
                this.actualizaCuestionario(true,null,true);
                this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.SUCC_TEXT_MOD_GUA_PLAN'), "OK");
                this.templateGuardado = true;
              }, 1100);
            });
          }
        });
      break;
      case 2:   //guardaCambiosAlOriginal

        Swal.fire({
          icon: 'question',
          title: titlePlantillaOriginal,
          showCancelButton: true,
reverseButtons: true,
          confirmButtonText: btnContinuar,
          cancelButtonText: btnCancelar,
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
          if (result.value) {
            this.preguntasService.saveCambiosTemplate(this.productoCertificar.surveyProductId._id, datos).subscribe((respuesta:any) => {
              console.log("saveCambiosTemplate:",respuesta);
              let nuevoSurveyProduct = JSON.parse(JSON.stringify(respuesta.surveyproduct));
              console.log("nuevoSurveyProduct:",nuevoSurveyProduct);
              this.jsonCuestionario = {};
              this.jsonCuestionario = nuevoSurveyProduct;
              setTimeout(() => {
                this.actualizaCuestionario(true,null,true);
                this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.SUCC_TEXT_MOD_GUA_PLAN_ORG'), "OK");
                this.templateGuardado = true;
              }, 1100);
            });
          }
        });
      break;
    }
  }

  cargaExcelTemplate(evt: any){
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});
      // console.log("hojas:",wb.SheetNames);
      this.tiposPreguntas.forEach(tipoSeccion => {
        let indiceHoja = wb.SheetNames.findIndex(item => item.includes(tipoSeccion.tipoSeccion + "-"));  //busca el nombre de la hoja por la clave y guión: "1-", "2-", etc
        const wsname: string = wb.SheetNames[indiceHoja];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        const datosHoja = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
        console.log("tipoSeccion:",tipoSeccion.nombre, "datosHoja:",datosHoja);
        //recorre el arreglo de datos de la hoja
        datosHoja.forEach((fila,i) => {
          if(i > 0){    //se salta la primera fila, de los nombres de columnas

          }
        });
      });
    };
    reader.readAsBinaryString(target.files[0]);
    evt.target.value = '';
  }

  conversionTipoPreguntaExcel(tipo:string){
    let answerType: number;
    switch (tipo) {
      case "2": answerType = 3; break;  //reactivo
      case "3": answerType = 2; break;  //abierta
      case "4": answerType = 4; break;  //pregunta una opcion
      case "5": answerType = 6; break;  //pregunta multiopcion
    }
    return answerType;
  }

  cargaArchivoPreg(evt: any, indiceSeccion:number, indicePregunta:number){
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    console.log("Seccion:",indiceSeccion);
    console.log("Pregunta:",indicePregunta);
    console.log("extension:",target.files[0].type);
    $("#fileBt"+indiceSeccion+"_"+indicePregunta).hide();
    // $("#fileSpin"+indiceSeccion+"_"+indicePregunta).css("display","flex");
    this.cargandoFilePreg = !this.cargandoFilePreg;
    setTimeout(() => {
      $("#fileBt"+indiceSeccion+"_"+indicePregunta).show();
      // $("#fileSpin"+indiceSeccion+"_"+indicePregunta).hide();
      this.cargandoFilePreg = !this.cargandoFilePreg;
    }, 3000);

  }

  agregaPregunta_paso1(direccion:number, indiceSeccion:number, indicePregunta:number){
    let permisoCompleto: boolean;
    switch (direccion) {
      case 1:   //arriba
        //no hace nada :v
      break;
      case 2: //abajo
        if((indicePregunta + 1) <= this.seccionesDemo[indiceSeccion].questions.length){
          indicePregunta++;
        }
        else{
          indicePregunta = this.seccionesDemo[indiceSeccion].questions.length;
        }
      break;
    }
    if(this.modoEmpresa){ //si es el modo empresa revisa los permisos y con base en ellos, muestra una ventana diferente
      if(this.configTemplate.nuevasPreguntas && !this.configTemplate.preguntasMC){ //si permite preguntas nuevas pero no de MC
        this.preguntaNuevaOpciones(indiceSeccion,indicePregunta);
      }
      else if(!this.configTemplate.nuevasPreguntas && this.configTemplate.preguntasMC){ //si no permite preguntas nuevas pero si de MC
        this.preguntaDeCatalogo(indiceSeccion,indicePregunta);
      }
      else if(this.configTemplate.nuevasPreguntas && this.configTemplate.preguntasMC){ //si permite preguntas nuevas y de MC
        permisoCompleto = true;
      }
    }
    if(!this.modoEmpresa || permisoCompleto){ //si es el modo itbm, o en el modo empresa tiene todos los permisos para agregar
      let text1 = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MENS_1');
      let text2 = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MENS_2');
      let btnNueva = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_NEW');
      let btncatal = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_D_CATA');
      Swal.fire({
        icon: 'question',
        title: text1,
        text: text2,
        showCancelButton: true,
reverseButtons: true,
        confirmButtonText: btnNueva,
        cancelButtonText: btncatal,
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.value) {   //pregunta nueva
          this.preguntaNuevaOpciones(indiceSeccion,indicePregunta);
        }
        else{   //pregunta de catalogo
          this.preguntaDeCatalogo(indiceSeccion,indicePregunta);
        }
      });
    }
  }

  cambiaVersionPregunta(datosPregunta:any, indiceSeccion:number, indicePregunta:number, indicePregCat:number, indiceVersionPregCat:number){
    console.log("datosPregunta:",datosPregunta);
    console.log("indicePregCat:",indicePregCat);
    console.log("datosPreguntaCat:",this.catalogoDemo[indicePregCat]);
    console.log("indiceVersionPregCat:",indiceVersionPregCat);
    this.seccionesDemo[indiceSeccion].questions[indicePregunta].versionId = this.catalogoDemo[indicePregCat].textVersions[indiceVersionPregCat].versionId;
    this.seccionesDemo[indiceSeccion].questions[indicePregunta].questionLanguage = this.catalogoDemo[indicePregCat].textVersions[indiceVersionPregCat].questionLanguage;
    console.log("secionesDemo:",this.seccionesDemo);
    this.actualizaCuestionario();
  }

  cambiaBanderaPregunta(event:any, indiceSeccion:number, indicePregunta:number, banderaRequired?:boolean){
    console.log("statusBandera:",event.checked);
    console.log("statusBandera:",event.target);
    if(banderaRequired){
      switch (event.checked) {
        case true:
          this.seccionesDemo[indiceSeccion].questions[indicePregunta].required = 1;
        break;
        case false:
          this.seccionesDemo[indiceSeccion].questions[indicePregunta].required = 0;
        break;
      }
    }

    if(this.seccionesDemo[indiceSeccion].questions[indicePregunta].idUnique < 99999){  //solo se considera preguntas agregadas de catalogo (idUnique < 99999), si el idUnique es mayor, por default la pregunta ya es considerada nueva en el template
      this.seccionesDemo[indiceSeccion].questions[indicePregunta].typeAdd = 1;
    }
    this.actualizaCuestionario();
  }

  cambiaBanderaPreguntaText(event:any, indiceSeccion:number, indicePregunta:number, banderaRequired?:boolean){
    console.log("statusBandera:",event.target);

      if (event.target.value.length>0) {
        this.seccionesDemo[indiceSeccion].questions[indicePregunta].typeCustom = 2;
        this.seccionesDemo[indiceSeccion].questions[indicePregunta].key = event.target.value;
    }

    if(this.seccionesDemo[indiceSeccion].questions[indicePregunta].idUnique < 99999){  //solo se considera preguntas agregadas de catalogo (idUnique < 99999), si el idUnique es mayor, por default la pregunta ya es considerada nueva en el template
      this.seccionesDemo[indiceSeccion].questions[indicePregunta].typeAdd = 1;
    }
    this.actualizaCuestionario();
  }


  cambiaBanderaPreguntaTypeCustom(event:any, indiceSeccion:number, indicePregunta:number, banderaRequired?:boolean){
    console.log("statusBandera:",event.value);
    if (event.value==1) {
      this.seccionesDemo[indiceSeccion].questions[indicePregunta].typeCustom = 1;
      if(this.seccionesDemo[indiceSeccion].questions[indicePregunta].idUnique < 99999){  //solo se considera preguntas agregadas de catalogo (idUnique < 99999), si el idUnique es mayor, por default la pregunta ya es considerada nueva en el template
        this.seccionesDemo[indiceSeccion].questions[indicePregunta].typeAdd = 1;
      }
      this.actualizaCuestionario();
    }else if (event.value==2) {
      if (this.seccionesDemo[indiceSeccion].questions[indicePregunta].key != "") {
        this.seccionesDemo[indiceSeccion].questions[indicePregunta].typeCustom = 2;
        if(this.seccionesDemo[indiceSeccion].questions[indicePregunta].idUnique < 99999){  //solo se considera preguntas agregadas de catalogo (idUnique < 99999), si el idUnique es mayor, por default la pregunta ya es considerada nueva en el template
          this.seccionesDemo[indiceSeccion].questions[indicePregunta].typeAdd = 1;
        }
        this.actualizaCuestionario();
      }else{
        this.textClaveMostrar=true;
      }
    }
    }


  agregaSeccionTemplate(indiceSeccion:number, seccionEspecial?:boolean){
    if(!seccionEspecial){
      if(this.configTemplate.secNombresObligatorios){
        this.agregaSeccionTemplate_paso2(indiceSeccion);
      }
      else{
        this.agregaSeccionTemplate_paso3(indiceSeccion, "");
      }
    } else{
      this.agregaSeccionTemplate_paso3(indiceSeccion + 1, "", 2);
    }
  }

  agregaSeccionTemplate_paso2(indiceSeccion:number){
    let tituloNewSecc = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_MOD_NEW_SECC');
    let textNewSecc = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_MOD_NEW_SECC');
    let returns = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.RETUR_MOD_GUA_CAM_TEMP');
    let btnCancelar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CAN_MOD_GUA_CAM_TEMP');
    let btnAgregar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_AGRE_MOD_GUA_CAM_TEMP');
    Swal.fire({
      title: tituloNewSecc,
      text: textNewSecc,
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: btnAgregar,
      cancelButtonText: btnCancelar,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      inputValidator: nombrePregunta => {
        // Si el valor es válido, debes regresar undefined. Si no, una cadena
        if (!nombrePregunta) {
          return returns;
        } else {
            return undefined;
        }
      }
    }).then((result) => {
      if (result.value) {
        this.agregaSeccionTemplate_paso3(indiceSeccion, result.value);
      }
    });
  }

  agregaSeccionTemplate_paso3(indiceSeccion:number, nombre:string, especial?:number){
    let idiomasNuevaSeccion: any[] = [];
    let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == 1);
    this.catalogoIdiomasSurvey.forEach(idioma => {
      let textoPreguntaNuevo = "";
      if(idioma.abbr == this.idiomas[indiceIdiomaNativo].nombreIdioma){
        textoPreguntaNuevo = nombre;
      }
      idiomasNuevaSeccion.push({
        idLanguage: idioma.idLanguage,
        lang: idioma.abbr,
        textSection: textoPreguntaNuevo,
        vivo: 1
      });
    });
    let seccionNueva:any = {
      addCatQuestions: this.configTemplate.preguntasMC,
      addNewQuestions: this.configTemplate.nuevasPreguntas,
      color: 1,
      deleteQuestions: this.configTemplate.eliminables,
      editQuestions: this.configTemplate.editables,
      logicSection: "",
      maxQuestions: this.configTemplate.limites.preguntasMaximas,
      moveQuestions: this.configTemplate.movibles,
      enableAudio: this.configTemplate.audios,
      // nameSection: nombre == "" ? this.tiposPreguntas[this.tipoPregSel].nombre : nombre,
      nameSection: this.tiposPreguntas[this.tipoPregSel].nombre,
      orderSection: 99,
      pendientesMC: false,
      questions: [],
      sectionsLanguages: idiomasNuevaSeccion,
      typeSection: this.tiposPreguntas[this.tipoPregSel].tipoSeccion,
      // typeCustom: 1,
      typeCustom: especial != undefined ? especial : 1,
      tagCustom: '',
      vivo: 1
    };
    if(this.tiposPreguntas[this.tipoPregSel].tipoInterfaz == 2){
      seccionNueva.pendientesOpciones = false;
    }
    this.seccionesDemo.splice(indiceSeccion,0,seccionNueva);
    Swal.close();
    this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_SUCC_PREG_AGRE'), "OK");
    this.actualizaListasPreguntas();
    this.actualizaOrdenSeccionesTemplate();
    this.actualizaCuestionario();
    // this.templateGuardado = false;
  }

  editaSeccionTemplate(indiceSeccion:number){
    let tituModif = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_MOD_EDI_SECC');
    let returns = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.RETUR_MOD_GUA_CAM_TEMP');
    let btnCancelar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CAN_MOD_GUA_CAM_TEMP');
    let btnAgregar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_AGRE_MOD_GUA_CAM_TEMP');
    let valorActual = this.seccionesDemo[indiceSeccion].sectionsLanguages[this.seccionesDemo[indiceSeccion].sectionsLanguages.findIndex(item => item.lang == this.idiomaNative)].textSection;
    Swal.fire({
      title: tituModif,
      input: 'text',
      inputValue: valorActual,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: btnAgregar,
      cancelButtonText: btnCancelar,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      inputValidator: nombreSeccion => {
        // Si el valor es válido, debes regresar undefined. Si no, una cadena
        if (!nombreSeccion) {
          if(this.configTemplate.secNombresObligatorios){
            return returns;
          }
          else return "";
        } else {
            return undefined;
        }
      }
    }).then((result) => {
      console.log("rsult:",result);

      if (result.value != null) {
        // this.seccionesDemo[indiceSeccion].nombre = result.value;
        if(result.value != ""){
          this.seccionesDemo[indiceSeccion].sectionsLanguages[this.seccionesDemo[indiceSeccion].sectionsLanguages.findIndex(item => item.lang == this.idiomaNative)].textSection = result.value;
        }
        else{
          this.seccionesDemo[indiceSeccion].sectionsLanguages.forEach(traduccion => {
            traduccion.textSection = '';
          });
        }
        Swal.close();
        this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_SUCC_MODIF_GRU'), "");
        // this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_SUCC_PREG_AGRE'), "OK");
        this.actualizaCuestionario();
        // this.templateGuardado = false;
      }
    });
  }

  borraSeccionTemplate(indiceSeccion:number){

    let titulo1 = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_MOD_DELE_SECC_TEMPLA');
    let titulo2 = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_MOD_DELE_SECC_TEMPLA2');
    let btnSi = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_SI');
    let btnNo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_NO');
    let btnConfDel = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_DELE_PRE');
    let btnCancTra = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CAN_TRAN');

    Swal.fire({
      title: titulo1,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: btnSi,
      cancelButtonText: btnNo,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        if(this.seccionesDemo[indiceSeccion].questions.length > 0){
          Swal.fire({
            title: titulo2,
            icon: 'warning',
            confirmButtonText: btnConfDel,
            showCancelButton: true,
reverseButtons: true,
            cancelButtonText: btnCancTra,
            showLoaderOnConfirm: true,
            width: '50%',
            allowOutsideClick: () => !Swal.isLoading()
          }).then((result) => {
            if (result.value) {   //borrarlas
              this.seccionesDemo.splice(indiceSeccion,1);
            }
            else{ //transferirlas
              let indiceNuevo = 0;
              if(indiceSeccion > 0){
                indiceNuevo = indiceSeccion - 1;
              }
              this.seccionesDemo[indiceSeccion].questions.forEach(pregunta => {
                this.seccionesDemo[indiceNuevo].questions.push(pregunta);
              });
              this.seccionesDemo.splice(indiceSeccion,1);
            }
            Swal.close();
            this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_SUCC_DELE_PREG'), "OK");
            this.actualizaListasPreguntas();
            this.actualizaCuestionario();
          });
        }
        else{
          this.seccionesDemo.splice(indiceSeccion,1);
          Swal.close();
          this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_SUCC_DELE_PREG'), "OK");
          this.actualizaListasPreguntas();
          this.actualizaCuestionario();
        }
      }
    });
  }

  // agregaPregunta_paso2ATemplate(direccion:number, indiceSeccion:number, indicePregunta:number){
  //   let titulo1 = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_AGRE_NEW_PREG');
  //   let text = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_AGRE_NEW_PREG');
  //   let btnCancelar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CAN_MOD_GUA_CAM_TEMP');
  //   let btnAgregar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_AGRE_MOD_GUA_CAM_TEMP');
  //   let returns = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.RETUR_MOD_GUA_CAM_TEMP');
  //   Swal.fire({
  //     title: titulo1,
  //     text: text,
  //     input: 'textarea',
  //     inputAttributes: {
  //       autocapitalize: 'off'
  //     },
  //     showCancelButton: true,
  //     confirmButtonText: btnAgregar,
  //     cancelButtonText: btnCancelar,
  //     showLoaderOnConfirm: true,
  //     allowOutsideClick: () => !Swal.isLoading(),
  //     inputValidator: nombrePregunta => {
  //       // Si el valor es válido, debes regresar undefined. Si no, una cadena
  //       if (!nombrePregunta) {
  //           return returns;
  //       } else {
  //           return undefined;
  //       }
  //     }
  //   }).then((result) => {
  //     if (result.value) {
  //       switch (direccion) {
  //         case 1:   //arriba
  //           //no hace nada :v
  //         break;
  //         case 2: //abajo
  //           if((indicePregunta + 1) <= this.seccionesDemo[indiceSeccion].questions.length){
  //             indicePregunta++;
  //           }
  //           else{
  //             indicePregunta = this.seccionesDemo[indiceSeccion].questions.length;
  //           }
  //         break;
  //       }
  //       let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == 1);
  //       let idiomasNuevaPreguntaEmpresa: any[] = [];
  //       this.catalogoIdiomasSurvey.forEach(idioma => {
  //         let textoPreguntaNuevo = "";
  //         if(idioma.abbr == this.idiomas[indiceIdiomaNativo].nombreIdioma){
  //           textoPreguntaNuevo = result.value;
  //         }
  //         idiomasNuevaPreguntaEmpresa.push({
  //           idLanguage: idioma.idLanguage,
  //           lang: idioma.abbr,
  //           question: textoPreguntaNuevo,
  //           vivo: 1
  //         });
  //       });
  //       // this.idiomas.forEach(idioma => {
  //       //   if(idioma.tipoIdioma == 0 || idioma.tipoIdioma == 1){
  //       //     let indiceIDlangSurv = this.catalogoIdiomasSurvey.findIndex(item => item.abbr == idioma.nombreIdioma);
  //       //     let textoPreguntaNuevo = "";
  //       //     if(idioma.tipoIdioma == 1){
  //       //       textoPreguntaNuevo = result.value;
  //       //     }
  //       //     idiomasNuevaPreguntaEmpresa.push({
  //       //       idLanguage: this.catalogoIdiomasSurvey[indiceIDlangSurv].idLanguage,
  //       //       lang: idioma.nombreIdioma,
  //       //       question: textoPreguntaNuevo,
  //       //       vivo: 1
  //       //     });
  //       //   }
  //       // });
  //       let idiomasNuevaPreguntaItbm: any[] = [];
  //       this.catalogoIdiomasSurvey.forEach(idioma => {
  //         let textoPreguntaNuevo = "";
  //         if(idioma.abbr == this.idiomas[indiceIdiomaNativo].nombreIdioma){
  //           textoPreguntaNuevo = result.value;
  //         }
  //         idiomasNuevaPreguntaItbm.push({
  //           idLanguage: idioma.idLanguage,
  //           lang: idioma.abbr,
  //           question: textoPreguntaNuevo,
  //           vivo: 1
  //         });
  //       });
  //       if(this.modoEmpresa){ //si es el modo empresa la pregunta se agrega solo al tempalte
  //         let datosNuevaPregunta: any = {
  //           answerType: this.tiposPreguntas[this.tipoPregSel].tipoPregEncuesta[0],
  //           answers: this.catalogoRespReactivos,
  //           color: 1,
  //           columns: this.jsonCuestionario.columns,
  //           delete: true,
  //           edit: true,
  //           idUnique: this.buscaUltimaIdUnique99999(),
  //           order: 1,
  //           preload: false,
  //           questionLanguage: idiomasNuevaPreguntaEmpresa,
  //           required: 1,
  //           typeAdd: 2, //enCM es ahora "typeAdd", 0 es pregunta en tempalte, 1 es pregunta de catalogo no en template y 2 es pregunta nueva no en template ni catalogo
  //           versionId: 1,
  //           vivo: 1,
  //           editarPregunta: false
  //         };
  //         this.seccionesDemo[indiceSeccion].questions.splice(indicePregunta,0,datosNuevaPregunta);
  //         // console.log("seccionesDemo:",this.seccionesDemo);
  //
  //         Swal.close();
  //         this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_SUCC_PREG_AGRE'), "OK");
  //         this.actualizaCuestionario();
  //       }
  //       else if(!this.modoEmpresa){ //si no es el modo empresa se agrega la pregunta al catalogo y luego al template
  //         let objAnswers: any[] = [];
  //         this.catalogoRespReactivos.forEach((respuesta,i) => {
  //           let objAnswer: any = {
  //             idUnique: respuesta.idUnique,
  //             value: (i+1).toString(),
  //             textVersions:[
  //               {
  //                 versionId: 1,
  //                 answerLanguage: respuesta.answerLanguage
  //               }
  //             ]
  //           };
  //           objAnswers.push(objAnswer);
  //         });
  //         let datosPreguntaCat = {
  //           answerType: this.tiposPreguntas[this.tipoPregSel].tipoPregEncuesta[0],
  //           answers: objAnswers,
  //           textVersions: [
  //             {
  //               questionLanguage: idiomasNuevaPreguntaItbm,
  //               versionId: 1
  //             }
  //           ],
  //           typeSection: this.tiposPreguntas[this.tipoPregSel].tipoSeccion,
  //           broker: localStorage.getItem('instituto_id')
  //         };
  //         let preguntasGuardar = {
  //           questions: [datosPreguntaCat]
  //         };
  //         console.log("datosPreguntaCatMod:",datosPreguntaCat);
  //         this.preguntasService.savePreguntaCatMaster(preguntasGuardar).subscribe((respuesta:any) => {
  //           console.log("savePreguntaCatMaster:",respuesta);
  //           if(respuesta.success){
  //             respuesta.newQuestions.forEach((pregNueva:any) => {
  //               pregNueva.ocupada = false;
  //               this.catalogoDemo.push(pregNueva);
  //               this.idsUniqueOcupadas.push(pregNueva.idUnique);
  //               this.seccionesDemo[indiceSeccion].questions.splice(indicePregunta,0,this.mapJsonPregCatJsonPregunta(pregNueva));
  //             });
  //             // console.log("seccionesDemo:",this.seccionesDemo);
  //             Swal.close();
  //             this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_SUCC_PREG_AGRE'), "OK");
  //             // this.templateGuardado = false;
  //             this.actualizaCuestionario();
  //           }
  //         });
  //       }
  //     }
  //   });
  // }

  mapJsonPregCatJsonPregunta(preguntaCat: any, versionSel?:number){ //esta funcion transforma el json de una pregunta de catalogo a json de pregunta del template
    let answersPregTemp: any[] = [];
    preguntaCat.answers.forEach(answCat => {
      let ansPregTemp = {
        answerLanguage: answCat.textVersions[0].answerLanguage,
        idUnique: answCat.idUnique,
        logics: [],
        value: answCat.value,
        versionId: 1,
        vivo: answCat.vivo,
      };
      answersPregTemp.push(ansPregTemp);
    });
    let indiceVersion = 0;
    let versionElegida = 1;
    if(versionSel){
      indiceVersion = preguntaCat.textVersions.findIndex(item => item.versionId == versionSel);
      versionElegida = versionSel;
    }
    let preguntaTemplate = {
      answerType: preguntaCat.answerType,
      answers: answersPregTemp,
      color: 1,
      columns: this.jsonCuestionario.columns,
      delete: true,
      demographicId: preguntaCat.demographicId,
      edit: true,
      idUnique: preguntaCat.idUnique,
      jsonCustom: preguntaCat.jsonCustom,
      order: 1,
      preload: false,
      questionLanguage: preguntaCat.textVersions[indiceVersion].questionLanguage,
      required: 1,
      typeAdd: 1, //enCM es ahora "typeAdd", 0 es pregunta en tempalte, 1 es pregunta de catalogo no en template y 2 es pregunta nueva no en template ni catalogo
      versionId: versionElegida,
      vivo: 1,
      typeCustom: preguntaCat.typeCustom,
      key: preguntaCat.key
    };
    return preguntaTemplate;
  }

  editaPreguntaTemplate(datosPregunta:any, indiceSeccion:any, indicePregunta:any){
    let titulo = this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_EDIT_PREG_MOD_PREG");
    let btnCancelar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CAN_MOD_GUA_CAM_TEMP');
    let btnContinuar = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CONTI_MOD_GUA_CAM_TEMP');
    let valor: any;
    let indiceIdioma = datosPregunta.questionLanguage.findIndex(item => item.lang == this.idiomaNative);
    valor = datosPregunta.questionLanguage[indiceIdioma].question;

    Swal.fire({
      title: titulo,
      input: 'textarea',
      inputValue: valor,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: btnContinuar,
      cancelButtonText: btnCancelar,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      let datosPregunta = this.seccionesDemo[indiceSeccion].questions[indicePregunta];
      if(this.modoEmpresa){    //modificar como empresa
        if (result.value) {
          datosPregunta.questionLanguage[indiceIdioma].question = result.value;
          datosPregunta.typeAdd = 2;
          this.seccionesDemo[indiceSeccion].questions[indicePregunta] = datosPregunta;
          Swal.close();
          this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_MOD_PREG_SUCC'), "OK");
          // this.templateGuardado = false;
          this.actualizaCuestionario();
          // console.log("seccionesDemo:",this.seccionesDemo);
        }
      }
      else if(!this.modoEmpresa){   //modo itbm
        if (result.value) {
          let tituloMod = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_2_OPCIO');
          let btnConAc = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CONF_ACT');
          let btnCanNe = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CANC_NEW');
          Swal.fire({
            title: tituloMod,
            showCancelButton: true,
reverseButtons: true,
            confirmButtonText: btnConAc,
            cancelButtonText: btnCanNe,
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading()
          }).then((resultadoItbm) => {
            this.editaPreguntaTemplate_paso2(result, resultadoItbm, indiceIdioma, datosPregunta, indiceSeccion, indicePregunta);
          });
        }
      }

    });
  }

  async editaPreguntaTemplate_paso2(result:any, resultadoItbm:any, indiceIdioma:number, datosPregunta:any, indiceSeccion:any, indicePregunta:any){
    let confirMsg: string;
    if (resultadoItbm.value) {  //actualizar version
      //actualiza texto de la pregunta en el template
      datosPregunta.questionLanguage[indiceIdioma].question = result.value;
      confirMsg = this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1");

      datosPregunta.typeAdd = 1;
      this.seccionesDemo[indiceSeccion].questions[indicePregunta] = datosPregunta;
      //actualiza texto de la pregunta en el catalogo
      // let indicePreguntaCat = this.catalogoDemo.findIndex(item => item.idUnique == datosPregunta.idUnique);
      /// HACER EL GETONE DEL CATALOGO MAESTRO
      // let datosPreguntaCat = this.catalogoDemo[indicePreguntaCat];
      let {question: datosPreguntaCat} = await this.preguntasService.getPreguntaCatMaster(datosPregunta.idUnique).toPromise();

      let indiceVersionPregCat = datosPreguntaCat.textVersions.findIndex(item => item.versionId == datosPregunta.versionId);
      let indiceLangVersPregCat = datosPreguntaCat.textVersions[indiceVersionPregCat].questionLanguage.findIndex(item => item.lang == this.idiomaNative);
      datosPreguntaCat.textVersions[indiceVersionPregCat].questionLanguage[indiceLangVersPregCat].question = result.value;
      console.log("datosPreguntaCatMod:",datosPreguntaCat);
      this.actualizaPreguntaCatMaster(datosPreguntaCat);

      Swal.close();
      this.openSnackBar(confirMsg, "OK");
      // this.templateGuardado = false;
      this.actualizaCuestionario();
      // console.log("seccionesDemo:",this.seccionesDemo);
    }
    else{   //guardar nueva version
      //guarda la nueva version en el catalogo
      /// HACER EL GETONE DEL CATALOGO MAESTRO
      // let indicePreguntaCat = this.catalogoDemo.findIndex(item => item.idUnique == datosPregunta.idUnique);
      // let datosPreguntaCat = this.catalogoDemo[indicePreguntaCat];
      let {question: datosPreguntaCat} = await this.preguntasService.getPreguntaCatMaster(datosPregunta.idUnique).toPromise();
      let idiomasNuevaVersion: any[] = [];
      let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == 1);
      this.catalogoIdiomasSurvey.forEach(idioma => {
        let textoPreguntaNuevo = "";
        if(idioma.abbr == this.idiomas[indiceIdiomaNativo].nombreIdioma){
          textoPreguntaNuevo = result.value;
        }
        idiomasNuevaVersion.push({
          idLanguage: idioma.idLanguage,
          lang: idioma.abbr,
          question: textoPreguntaNuevo,
          vivo: 1
        });
      });
      let datosNuevaVersion = {
        questionLanguage: idiomasNuevaVersion,
        versionId: datosPreguntaCat.textVersions.length + 1,
        vivo: 1
      };
      datosPreguntaCat.textVersions.push(datosNuevaVersion);
      console.log("datosPreguntaCatMod:",datosPreguntaCat);
      this.actualizaPreguntaCatMaster(datosPreguntaCat);

      datosPregunta.questionLanguage = datosNuevaVersion.questionLanguage;
      datosPregunta.versionId = datosNuevaVersion.versionId;
      datosPregunta.typeAdd = 1;

      confirMsg = this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1");

      this.seccionesDemo[indiceSeccion].questions[indicePregunta] = datosPregunta;
      Swal.close();
      this.openSnackBar(confirMsg, "OK");
      this.actualizaCuestionario();
    }
  }

  borraPreguntaTemplate(indiceSeccion:number, indicePregunta:number){
    let titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_DELE_PREG');
    let btnSi = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_SI');
    let btnNo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_NO');
    Swal.fire({
      title: titulo,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: btnSi,
      cancelButtonText: btnNo,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        let indiceUnique = this.idsUniqueOcupadas.indexOf(this.seccionesDemo[indiceSeccion].questions[indicePregunta].idUnique);
        if(indiceUnique != -1){
          this.idsUniqueOcupadas.splice(indiceUnique,1);
          let indicePregCat = this.catalogoDemo.findIndex(item => item.idUnique == this.seccionesDemo[indiceSeccion].questions[indicePregunta].idUnique);
          if(indicePregCat != -1){
            this.catalogoDemo[indicePregCat].ocupada = false;
          }
        }
        this.seccionesDemo[indiceSeccion].questions.splice(indicePregunta,1);
        console.log("idsUniqueOcupadas:",this.idsUniqueOcupadas);

        Swal.close();
        this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_SUCC_PREG'), "OK");
        // this.templateGuardado = false;
        switch (this.tipoSeccionActualizar) {
          case 1:
            this.accionText='deletePregTemNps';
            break;
          case 2:
            this.accionText='deletePregTemReacti';
            break;
          case 3:
            this.accionText='deletePregTemControl';
            break;
          case 4:
            this.accionText='deletePregTemDemogra';
            break;
          case 5:
            this.accionText='deletePregTemAbier';
            break;
          case 7:
            this.accionText='deletePregTemAdici';
            break;

          default:
            break;
        }
        this.actualizaCuestionario();
      }
    });
  }

  guardaNuevaPreguntaMC(datosPregunta: any, indiceSeccion:number, indicePregunta:number){
    console.log("datosPregunta:",datosPregunta);

    let idiomasNuevaPreguntaItbm: any[] = [];
    let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == 1);
    this.catalogoIdiomasSurvey.forEach(idioma => {
      let textoPreguntaNuevo = "";
      if(idioma.abbr == this.idiomas[indiceIdiomaNativo].nombreIdioma){
        textoPreguntaNuevo = datosPregunta.questionLanguage[datosPregunta.questionLanguage.findIndex(item => item.lang == this.idiomaNative)].question;
      }
      idiomasNuevaPreguntaItbm.push({
        idLanguage: idioma.idLanguage,
        lang: idioma.abbr,
        question: textoPreguntaNuevo,
        vivo: 1
      });
    });

    let objAnswers: any[] = [];
    this.catalogoRespReactivos.forEach((respuesta,i) => {
      console.log('catalogoRespReactivos',respuesta);

      let objAnswer: any = {
        idUnique: respuesta.idUnique,
        value: (i+1).toString(),
        textVersions:[
          {
            versionId: 1,
            answerLanguage: respuesta.answerLanguage
          }
        ]
      };
      objAnswers.push(objAnswer);
    });
    let datosPreguntaCat = {
      answerType: this.tiposPreguntas[this.tipoPregSel].tipoPregEncuesta[0],
      answers: objAnswers,
      textVersions: [
        {
          questionLanguage: idiomasNuevaPreguntaItbm,
          versionId: 1
        }
      ],
      typeSection: this.tiposPreguntas[this.tipoPregSel].tipoSeccion,
      broker: localStorage.getItem('instituto_id')
    };
    let preguntasGuardar = {
      questions: [datosPreguntaCat]
    };
    console.log("preguntasGuardar:",preguntasGuardar);
    this.preguntasService.savePreguntaCatMaster(preguntasGuardar).subscribe((respuesta:any) => {
      console.log("savePreguntaCatMaster:",respuesta);
      if(respuesta.success){
        respuesta.newQuestions.forEach((pregNueva:any) => {
          pregNueva.ocupada = false;
          this.catalogoDemo.push(pregNueva);
          this.idsUniqueOcupadas.push(pregNueva.idUnique);
          this.seccionesDemo[indiceSeccion].questions[indicePregunta] = this.mapJsonPregCatJsonPregunta(pregNueva);
        });
        // console.log("seccionesDemo:",this.seccionesDemo);
        Swal.close();
        this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_SUCC_GUAR_PREG_'), "OK");
        this.actualizaCuestionario();
      }
    });
  }

  actualizaPreguntaMC(datosPregunta: any, indiceSeccion:number, indicePregunta:number){
    console.log("datosPregunta:",datosPregunta);
    let tituloMod = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_2_OPCIO');
    let btnConAc = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CONF_ACT');
    let btnCanNe = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_CANC_NEW');
    const modal = Swal.fire({
      title: tituloMod,
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: btnConAc,
      cancelButtonText: btnCanNe,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((resultadoItbm) => {
      this.actualizaPreguntaMC_paso2(resultadoItbm, datosPregunta, indiceSeccion, indicePregunta);
    });
  }

  async actualizaPreguntaMC_paso2(status:any, datosPregunta: any, indiceSeccion:number, indicePregunta:number){
    let confirMsg: string;
    if (status.value) {  //actualizar version
      //actualiza texto de la pregunta en el template
      confirMsg = this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1");
      datosPregunta.typeAdd = 1;
      //actualiza texto de la pregunta en el catalogo
      /// HACER EL GETONE DEL CATALOGO MAESTRO
      // let indicePreguntaCat = this.catalogoDemo.findIndex(item => item.idUnique == datosPregunta.idUnique);
      // let datosPreguntaCat = this.catalogoDemo[indicePreguntaCat];
      let {question: datosPreguntaCat} = await this.preguntasService.getPreguntaCatMaster(datosPregunta.idUnique).toPromise();
      let indiceVersionPregCat = datosPreguntaCat.textVersions.findIndex(item => item.versionId == datosPregunta.versionId);
      let indiceLangVersPregCat = datosPreguntaCat.textVersions[indiceVersionPregCat].questionLanguage.findIndex(item => item.lang == this.idiomaNative);
      datosPreguntaCat.textVersions[indiceVersionPregCat].questionLanguage[indiceLangVersPregCat].question = datosPregunta.questionLanguage[datosPregunta.questionLanguage.findIndex(item => item.lang == this.idiomaNative)].question;
      console.log("datosPreguntaCatMod:",datosPreguntaCat);
      this.actualizaPreguntaCatMaster(datosPreguntaCat);

      Swal.close();
      this.openSnackBar(confirMsg, "OK");
      this.actualizaCuestionario();
    }
    else{   //guardar nueva version
      //guarda la nueva version en el catalogo
      /// HACER EL GETONE DEL CATALOGO MAESTRO
      // let indicePreguntaCat = this.catalogoDemo.findIndex(item => item.idUnique == datosPregunta.idUnique);
      // let datosPreguntaCat = this.catalogoDemo[indicePreguntaCat];
      let {question: datosPreguntaCat} = await this.preguntasService.getPreguntaCatMaster(datosPregunta.idUnique).toPromise();
      let idiomasNuevaVersion: any[] = [];
      let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == 1);
      this.catalogoIdiomasSurvey.forEach(idioma => {
        let textoPreguntaNuevo = "";
        if(idioma.abbr == this.idiomas[indiceIdiomaNativo].nombreIdioma){
          textoPreguntaNuevo = datosPregunta.questionLanguage[datosPregunta.questionLanguage.findIndex(item => item.lang == this.idiomaNative)].question;
        }
        idiomasNuevaVersion.push({
          idLanguage: idioma.idLanguage,
          lang: idioma.abbr,
          question: textoPreguntaNuevo,
          vivo: 1
        });
      });
      let datosNuevaVersion = {
        questionLanguage: idiomasNuevaVersion,
        versionId: datosPreguntaCat.textVersions.length + 1,
        vivo: 1
      };
      datosPreguntaCat.textVersions.push(datosNuevaVersion);
      console.log("datosPreguntaCatMod:",datosPreguntaCat);
      this.actualizaPreguntaCatMaster(datosPreguntaCat);

      datosPregunta.questionLanguage = datosNuevaVersion.questionLanguage;
      datosPregunta.versionId = datosNuevaVersion.versionId;
      datosPregunta.typeAdd = 1;

      confirMsg = this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_CONFIR_MSG1");

      this.seccionesDemo[indiceSeccion].questions[indicePregunta] = datosPregunta;
      Swal.close();
      this.openSnackBar(confirMsg, "OK");
      this.actualizaCuestionario();
    }
  }

  async borraPreguntaMC(datosPregunta: any, indiceSeccion:number, indicePregunta:number){
    console.log("datosPregunta:",datosPregunta);
    /// HACER EL GETONE DEL CATALOGO MAESTRO
    // let indicePreguntaCat = this.catalogoDemo.findIndex(item => item.idUnique == datosPregunta.idUnique);
    // let datosPreguntaCat = this.catalogoDemo[indicePreguntaCat];
    let {question: datosPreguntaCat} = await this.preguntasService.getPreguntaCatMaster(datosPregunta.idUnique).toPromise();
    datosPreguntaCat.vivo = 0;
    console.log("datosPreguntaCatMod:",datosPreguntaCat);

    let titulo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_MOD_DELE_PREG_MG');
    let btnSi = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_SI');
    let btnNo = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_NO');

    Swal.fire({
      icon: 'question',
      title: titulo,
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: btnSi,
      cancelButtonText: btnNo,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        this.actualizaPreguntaCatMaster(datosPreguntaCat,indiceSeccion,indicePregunta);
      }
    });
  }

  actualizaPreguntaCatMaster(pregunta:any, indiceSeccion?:number, indicePregunta?:number){
    this.preguntasService.setPreguntaCatMaster(pregunta).subscribe((respuesta:any) => {
      console.log("setPreguntaCatMaster:",respuesta);
      if(respuesta.success){
        let confirMsg: string;
        if(pregunta.vivo == 0){
          let indiceUnique = this.idsUniqueOcupadas.indexOf(pregunta.idUnique);
          if(indiceUnique != -1){
            this.idsUniqueOcupadas.splice(indiceUnique,1);
            let indicePregCat = this.catalogoDemo.findIndex(item => item.idUnique == pregunta.idUnique);
            if(indicePregCat != -1){
              this.catalogoDemo.splice(indicePregCat,1);
            }
          }
          this.seccionesDemo[indiceSeccion].questions.splice(indicePregunta,1);
          confirMsg = this.translateSrv.instant("CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TITU_MOD_DELE_PREG_MG");
          this.openSnackBar(confirMsg, "OK");
        }
        else{
          let indicePregCat = this.catalogoDemo.findIndex(item => item.idUnique == respuesta.question.idUnique);
          if(indicePregCat != -1){
            this.catalogoDemo[indicePregCat] = respuesta.question;
          }
        }
      }
    });
  }

  actualizaCuestionario(reiniciar?:boolean, desdeTraducciones?:boolean, sinFiltros?:boolean, reiniciaCatalogo?:boolean){
    if(!this.pasoCompleto){
      if(sinFiltros == undefined){
        this.filtroIDUniqueOcupadas();
        this.buscaPendientesMC();
        this.buscaPendientesOpciones();
        // this.buscaPendientesForall();
        this.buscaCambiosTemplate();
        this.buscaPreguntasNuevasTemplate();
        this.actualizaOrdenSeccionesTemplate();
        this.actualizaListasPreguntas();
        this.enviaSeccionesDemo();
        console.log("jsonCuestionario:",this.jsonCuestionario);
        console.log("seccionesDemo:",this.seccionesDemo);
        this.typeCustomBooleanTrue=true;
        this.typeCustomBooleanFalse=false;
        this.textClaveMostrar=false;
      }
      this.guardandoTemplate.emit(true);
      if(!this.debugModos){
        setTimeout(() => {
          this.guardandoTemplate.emit(false);
        }, 2000);
      }
      if(this.debugModos){
        this.jsonCuestionario.accionText=this.accionText;
        this.jsonCuestionario.userAdministrator=this.nameUserAdmin;
        this.jsonCuestionario.section=this.tipoSeccionActualizar,
        this.jsonCuestionario.broker= parseInt(localStorage.getItem('instituto_id')),
        console.log('JsonCuestionarioActualizado',this.jsonCuestionario);

        this.preguntasService.setSeccionesCuestionario(this.productoCertificar.surveyProductId._id,this.jsonCuestionario).subscribe((respuesta:any) => {
          console.log("actualizaCuestionario:",respuesta);
          this.guardandoTemplate.emit(false);
          if(reiniciar != null){
            // this.getSeccionesCuestionario();
            this.surveyProductService.enviaDatosASurvProd({ actualizarProducto: true });
            this.recibeDatosSP();
          }
          if(desdeTraducciones == true){
            if(reiniciaCatalogo){
              // this.getCatalogoMaestro();
              this.surveyProductService.enviaDatosASurvProd({ actualizarCatalogo: true });
              this.recibeDatosSP();
            }
            Swal.close();
            this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_GUAR_TRADU_SUCC'), "OK");
          }
        });
      }
    }
  }

  async getQuestionAudio(idUnique:number, versionId:number, datosPregunta:any){
    const conAudio = (idioma) => {
      const datosIdioma = datosPregunta.questionLanguage.find(item => item.lang == idioma.nombreIdioma);
      if(datosIdioma != undefined){
        return datosIdioma.audio != undefined ? true : false;
      } else return true;
    }
    // datosPregunta.questionLanguage.forEach(idioma => {
    for (let idioma of datosPregunta.questionLanguage) {
      if(this.infoVoces[idioma.lang] != undefined){ //entra si el idioma de la traduccion es uno de los que se eligieron en la configuracion de idioma
        const datosURL = {
          idUnique,
          versionId,
          lang: idioma.lang,
          gender: this.infoVoces[idioma.lang].gender,
          languageCode: this.infoVoces[idioma.lang].languageCode,
          nameVoice: this.infoVoces[idioma.lang].nameVoice
        }
        const respuesta:any = await this.preguntasService.getQuestionAudio(datosURL).toPromise();//.subscribe((respuesta:any) => {
          if(respuesta.success == true){
            idioma.audio = true;
            idioma.audioUrl = respuesta.questionAudio.url;
          }
          idioma.audio = respuesta.success;
          // idioma.audioUrl = respuesta.
          if(this.idiomas.every(conAudio)){
            console.log("se consultaron los audios de todos los idiomas de la version ",versionId," idUnique ",idUnique);
            return;
          }
        // });
      }
    }
    // });
  }

  ///////////// FUNCIONES ABREN MODALES

  moverPregunta(indiceSeccion:number, indicePregunta:number){
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '50%',
      disableClose: true,
      data: {
        opcion: 'mover',
        secciones: this.seccionesDemo,
        indiceSeccion,
        indicePregunta,
        idiomas: this.idiomas,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result.indiceNuevo != null){
        this.seccionesDemo[result.indiceNuevo].questions.push(this.seccionesDemo[indiceSeccion].questions[indicePregunta]);
        this.seccionesDemo[indiceSeccion].questions.splice(indicePregunta,1);
        this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEX_MOVE_PREG_SECC'), "OK");
        this.actualizaCuestionario();
        // this.templateGuardado = false;
      }
    });
  }

  configuracionTemplate(modoAdmin: boolean){
    let totalPreguntas = 0;
    this.seccionesDemo.forEach(seccion => {
      totalPreguntas += seccion.questions.length;
    });
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '50%',
      disableClose: true,
      data: {
        opcion: 'config',
        configTemplate: this.configTemplate,
        nombre: this.jsonCuestionario.name,
        secciones: this.seccionesDemo.length,
        preguntas: totalPreguntas,
        idiomas: this.idiomas,
        tipoSeccion: this.tiposPreguntas[this.tipoPregSel].tipoSeccion,
        modoAdmin,
        datosSecciones: this.jsonCuestionario.sections
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.configTemplate = result;
      this.jsonCuestionario.editSections = result.secEditables;
      this.jsonCuestionario.addSections = result.nuevasSecciones;
      this.jsonCuestionario.deleteSections = result.secEliminables;
      this.jsonCuestionario.moveSections = result.secMovibles;
      this.jsonCuestionario.nameSections = result.secNombresObligatorios;
      this.jsonCuestionario.enableCustom = result.secEspeciales;

      this.seccionesDemo.forEach(seccion => {
        seccion.addCatQuestions = result.preguntasMC;
        seccion.addNewQuestions = result.nuevasPreguntas;
        seccion.deleteQuestions = result.eliminables;
        seccion.editQuestions = result.editables;
        seccion.moveQuestions = result.movibles;
        seccion.maxQuestions = result.limites.preguntasMaximas;
        seccion.enableAudio = result.audios;
      });
      this.actualizaCuestionario();
    });
  }

  async preguntaDeCatalogo(indiceSeccion:number, indicePregunta:number){
    if(this.configTemplate.audiosGlobal == true){
      this.recuperaConfigVoces();
    }
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '50%',
      disableClose: true,
      data: {
        opcion: 'preguntaCat',
        secciones: this.seccionesDemo,
        catalogo: this.catalogoDemo,
        indiceSeccion,
        indicePregunta,
        idiomas: this.idiomas,
        tipoPreguntaSeccion: this.tiposPreguntas[this.tipoPregSel].tipoPregEncuesta,
        idsUniqueOcupadas: this.idsUniqueOcupadas,
        nuevasRestantes: this.nuevasRestantes,
        catalogoIdiomasSurvey: this.catalogoIdiomasSurvey
      }
    });
    const result:any = await dialogRef.afterClosed().toPromise();
    console.log("addCat:",result);
    if(result.arrayPreguntas.length > 0){
      let pregTransformadasTempl: any[] = [];
      result.arrayPreguntas.forEach(pregCat => {
        this.idsUniqueOcupadas.push(pregCat.preguntaCat.idUnique);
        pregTransformadasTempl.push(this.mapJsonPregCatJsonPregunta(pregCat.preguntaCat,pregCat.indiceVersion));
        //REVISAR SI HAY PREGUNTAS A ACTUALIZAR DEL CATALOGO Y ACTUALIZARLAS
        if(pregCat.actualizarPregunta){
          this.actualizaPreguntaCatMaster(pregCat.preguntaCat);
        }
      });
      console.log("pregTransformadasTempl:",pregTransformadasTempl);

      //REVISAR SI TIENE AUDIOS ASOCIADOS
      if(this.configTemplate.audiosGlobal == true){
        Swal.fire({
          title: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.AGREGANDO_PREGUNTAS'),
          allowOutsideClick: false,
          showConfirmButton: false,
          imageUrl: localStorage.getItem('urlGifBroker'),
          imageWidth: 60
        });
        for (let pregunta of pregTransformadasTempl) {
          await this.getQuestionAudio(pregunta.idUnique, pregunta.versionId, pregunta);
        }
        console.log("terminó de analizar las preguntas");
        Swal.close();
      }
      this.seccionesDemo[indiceSeccion].questions.splice(indicePregunta, 0, ...pregTransformadasTempl);
      let textoOk: string;
      if(result.arrayPreguntas.length == 1){
        textoOk = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_SUCC_PREG_AGRE');
      }
      else{
        textoOk = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_MOD_SUCCE_CARG_LIS_COLAB');
      }
      this.openSnackBar(textoOk, "OK");
      // this.templateGuardado = false;
      switch (this.tipoSeccionActualizar) {
        case 1: this.accionText='savePregCatNps'; break;
        case 2: this.accionText='savePregCatReacti'; break;
        case 3: this.accionText='savePregCatControl'; break;
        case 4: this.accionText='savePregCatDemogra'; break;
        case 5: this.accionText='savePregCatAbier'; break;
        case 7: this.accionText='savePregCatAdici'; break;
        default: break;
      }
      this.actualizaCuestionario();
    }
  }

  preguntaNuevaOpciones(indiceSeccion:number, indicePregunta:number){
    const dialogRef = this.dialog.open(DetalleComponent, {
      width: '50%',
      disableClose: true,
      data: {
        opcion: 'preguntaOpc',
        tipoSeccion: this.tiposPreguntas[this.tipoPregSel].tipoSeccion,
        modoEmpresa: this.modoEmpresa,
        catalogoDemograficos: this.catalogoDemograficos,
        idiomaNativo: this.idiomaNative,
        configTemplate: this.configTemplate
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log("preguntaNuevaOpciones:",result);
      if(result != false){
        //Crea el arreglo de idiomas de la pregunta
        let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == 1);
        let idiomasNuevaPregunta: any[] = [];
        this.catalogoIdiomasSurvey.forEach(idioma => {
          let textoPreguntaNuevo = "";
          let descripcion = "";
          if(idioma.abbr == this.idiomas[indiceIdiomaNativo].nombreIdioma){
            textoPreguntaNuevo = result.pregunta;
            descripcion = result.descripcion;
          }
          idiomasNuevaPregunta.push({
            idLanguage: idioma.idLanguage,
            lang: idioma.abbr,
            question: textoPreguntaNuevo,
            descritionShort: descripcion,
            vivo: 1,
            audio: false
          });
        });
        // this.idiomas.forEach(idioma => {
        //   if(idioma.tipoIdioma == 0 || idioma.tipoIdioma == 1){
        //     let indiceIDlangSurv = this.catalogoIdiomasSurvey.findIndex(item => item.abbr == idioma.nombreIdioma);
        //     let textoPreguntaNuevo = "";
        //     if(idioma.tipoIdioma == 1){
        //       textoPreguntaNuevo = result.pregunta;
        //     }
        //     idiomasNuevaPregunta.push({
        //       idLanguage: this.catalogoIdiomasSurvey[indiceIDlangSurv].idLanguage,
        //       lang: idioma.nombreIdioma,
        //       question: textoPreguntaNuevo,
        //       vivo: 1
        //     });
        //   }
        // });
        let idiomasNuevaPreguntaItbm: any[] = [];
        this.catalogoIdiomasSurvey.forEach(idioma => {
          let textoPreguntaNuevo = "";
          if(idioma.abbr == this.idiomas[indiceIdiomaNativo].nombreIdioma){
            textoPreguntaNuevo = result.pregunta;
          }
          idiomasNuevaPreguntaItbm.push({
            idLanguage: idioma.idLanguage,
            lang: idioma.abbr,
            question: textoPreguntaNuevo,
            vivo: 1,
            audio: false
          });
        });

        //Crea el arreglo de idiomas de respuestas
        let objAnswers: any[] = [];
        let objAnswersCat: any[] = [];
        let objAnswersReactivoCat: any[] = [];
        this.catalogoRespReactivos.forEach((respuesta,i) => {
          console.log('catalogoRespReactivos',respuesta);
          let objAnswer: any = {
            idUnique: respuesta.idUnique,
            value: (i+1).toString(),
            textVersions:[
              {
                versionId: 1,
                answerLanguage: respuesta.answerLanguage
              }
            ]
          };
          objAnswersReactivoCat.push(objAnswer);
        });
        result.respuestasTextos.forEach((respuesta,i) => {

          let idiomasAnswer: any[] = [];
          let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == 1);
          this.catalogoIdiomasSurvey.forEach(idioma => {
            let textoPreguntaNuevo = "";
            if(idioma.abbr == this.idiomas[indiceIdiomaNativo].nombreIdioma){
              textoPreguntaNuevo = respuesta;
            }
            idiomasAnswer.push({
              idLanguage: idioma.idLanguage,
              lang: idioma.abbr,
              tag: textoPreguntaNuevo,
              vivo: 1
            });
          });
          // this.idiomas.forEach(idioma => {
          //   if(idioma.tipoIdioma == 0 || idioma.tipoIdioma == 1){
          //     let indiceIDlangSurv = this.catalogoIdiomasSurvey.findIndex(item => item.abbr == idioma.nombreIdioma);
          //     let textoPreguntaNuevo = "";
          //     if(idioma.tipoIdioma == 1){
          //       textoPreguntaNuevo = respuesta;
          //     }
          //     idiomasAnswer.push({
          //       idLanguage: this.catalogoIdiomasSurvey[indiceIDlangSurv].idLanguage,
          //       lang: idioma.nombreIdioma,
          //       tag: textoPreguntaNuevo,
          //       vivo: 1
          //     });
          //   }
          // });
          let idiomasAnswerItbm: any[] = [];
          this.catalogoIdiomasSurvey.forEach(idioma => {
            let textoPreguntaNuevo = "";
            if(idioma.abbr == this.idiomas[indiceIdiomaNativo].nombreIdioma){
              textoPreguntaNuevo = respuesta;
            }
            idiomasAnswerItbm.push({
              idLanguage: idioma.idLanguage,
              lang: idioma.abbr,
              tag: textoPreguntaNuevo,
              vivo: 1
            });
          });
          let objAnswer: any = {
            answerLanguage: idiomasAnswer,
            delete: true,
            edit: true,
            idUnique: (i+1),
            logics: [],
            value: (i+1).toString(),
            versionId: 1,
            vivo: 1,
          };
          let objAnswerCat: any = {
            idUnique: (i+1),
            value: (i+1).toString(),
            textVersions:[
              {
                versionId: 1,
                answerLanguage: idiomasAnswerItbm
              }
            ]
          };
          objAnswers.push(objAnswer);
          objAnswersCat.push(objAnswerCat);
        });

        //datos nueva pregunta para template
        // console.log('localStorage.getItem instituto_id',localStorage.getItem('instituto_id'));
        // console.log('tipoSeccionActualizar',this.tipoSeccionActualizar);
        let requiredPregNew:number;
        switch (this.tipoSeccionActualizar) {
          case 2: case 4: case 5:   //Reactivos, demograficos , abiertas
          if (localStorage.getItem('instituto_id')=='5') {
            requiredPregNew=0;
          }else{
            requiredPregNew=1;
          }
          break;

          default: requiredPregNew=1; break;

        }

        let datosNuevaPregunta: any = {
          answerType: result.tipo,
          color: 1,
          columns: this.jsonCuestionario.columns,
          delete: true,
          demographicId: result.demografico,
          edit: true,
          idUnique: this.buscaUltimaIdUnique99999(),
          order: 1,
          preload: false,
          questionLanguage: idiomasNuevaPregunta,
          required: requiredPregNew,
          typeAdd: 2, //enCM es ahora "typeAdd", 0 es pregunta en tempalte, 1 es pregunta de catalogo no en template y 2 es pregunta nueva no en template ni catalogo
          versionId: 1,
          vivo: 1,
          editarPregunta: false,
          typeCustom:result.typeCustom,
          key:result.key,
        };

        //datos nueva pregunta de catálogo
        let datosPreguntaCat: any = {
          answerType: result.tipo,
          demographicId: result.demografico,
          textVersions: [
            {
              questionLanguage: idiomasNuevaPreguntaItbm,
              versionId: 1
            }
          ],
          tags: result.tags,
          typeSection: this.tiposPreguntas[this.tipoPregSel].tipoSeccion,
          broker: localStorage.getItem('instituto_id'),
          typeCustom:result.typeCustom,
          key:result.key,
        };

        //añade datos extra segun el tipo de pregunta
        switch (result.tipo) {
          case 2: //abierta
            let jsonCustom = JSON.stringify(catalogos.jsonCustomAbiertas[catalogos.jsonCustomAbiertas.findIndex(item => item.tipo == result.tipoAbierta)].json); //cambiar el tipo de acuerdo al seleccionado en la modal
            datosPreguntaCat.jsonCustom = jsonCustom;
            datosNuevaPregunta.jsonCustom = jsonCustom;
            datosPreguntaCat.answers = objAnswersCat;
            datosNuevaPregunta.answers = objAnswers;
          break;
          case 3: //reactivo
            datosPreguntaCat.answers = objAnswersReactivoCat;
            datosNuevaPregunta.answers = this.catalogoRespReactivos;
          break;
          case 1: case 4: case 6: //nps opciones / una opcion / multiopcion
            datosPreguntaCat.answers = objAnswersCat;
            datosNuevaPregunta.answers = objAnswers;
          break;
        }

        if(this.modoEmpresa){ //si es el modo empresa la pregunta se agrega solo al tempalte
          console.log("datosNuevaPregunta:",datosNuevaPregunta);
          switch (this.tipoSeccionActualizar) {
            case 1:
              this.accionText='savePregNueNps';
              break;
            case 2:
              this.accionText='savePregNueReacti';
              break;
            case 3:
              this.accionText='savePregNueControl';
              break;
            case 4:
              this.accionText='savePregNueDemogra';
              break;
            case 5:
              this.accionText='savePregNueAbier';
              break;
            case 7:
              this.accionText='savePregNueAdici';
              break;

            default:
              break;
          }
          this.seccionesDemo[indiceSeccion].questions.splice(indicePregunta,0,datosNuevaPregunta);
          Swal.close();
          this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_SUCC_PREG_AGRE'), "OK");
          this.actualizaCuestionario();
        }
        else if(!this.modoEmpresa){ //si no es el modo empresa se agrega la pregunta al catalogo y luego al template
          let text1 = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_AGRE_PREG_DONDE_GUARDAR');
          let text2 = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.MOD_AGRE_PREG_DONDE_GUARDAR_INFO');
          let btnNueva = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BOT_DONDE_GUARDAR_1');
          let btncatal = this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BOT_DONDE_GUARDAR_2');
          Swal.fire({
            icon: 'question',
            title: text1,
            text: text2,
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: btnNueva,
            cancelButtonText: btncatal,
            showLoaderOnConfirm: true,
            width: '50%',
            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {   //al catalogo
              let preguntasGuardar = {
                questions: [datosPreguntaCat]
              };
              // this.accionText='savePreguntaCatalogo';
              console.log("datosPreguntaNuevaMod:",datosPreguntaCat);
              this.preguntasService.savePreguntaCatMaster(preguntasGuardar).subscribe((respuesta:any) => {
                console.log("savePreguntaCatMaster:",respuesta);
                if(respuesta.success){
                  respuesta.newQuestions.forEach((pregNueva:any) => {
                    pregNueva.ocupada = false;
                    this.catalogoDemo.push(pregNueva);
                    this.idsUniqueOcupadas.push(pregNueva.idUnique);
                    this.seccionesDemo[indiceSeccion].questions.splice(indicePregunta,0,this.mapJsonPregCatJsonPregunta(pregNueva));
                  });
                  Swal.close();
                  this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_SUCC_PREG_AGRE'), "OK");
                  switch (this.tipoSeccionActualizar) {
                    case 1: this.accionText='savePregNueNps'; break;
                    case 2: this.accionText='savePregNueReacti'; break;
                    case 3: this.accionText='savePregNueControl'; break;
                    case 4: this.accionText='savePregNueDemogra'; break;
                    case 5: this.accionText='savePregNueAbier'; break;
                    case 7: this.accionText='savePregNueAdici'; break;
                    default: break;
                  }
                  this.actualizaCuestionario();
                }
              });
            }
            else{   //a la encuesta
              console.log("datosNuevaPregunta:",datosNuevaPregunta);
              this.seccionesDemo[indiceSeccion].questions.splice(indicePregunta,0,datosNuevaPregunta);
              switch (this.tipoSeccionActualizar) {
                case 1: this.accionText='savePregNueNps'; break;
                case 2: this.accionText='savePregNueReacti'; break;
                case 3: this.accionText='savePregNueControl'; break;
                case 4: this.accionText='savePregNueDemogra'; break;
                case 5: this.accionText='savePregNueAbier'; break;
                case 7: this.accionText='savePregNueAdici'; break;
                default: break;
              }
              Swal.close();
              this.openSnackBar(this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.TEXT_SUCC_PREG_AGRE'), "OK");
              this.actualizaCuestionario();
            }
          });
        }
      }
    });
  }

  detallePregunta(indiceSeccion:number, indicePregunta:number, modoUsuario:boolean){
    const dialogRef = this.dialog.open(DetalleComponent, {
      width: '50%',
      disableClose: true,
      data: {
        opcion: 'detalle',
        pregunta: this.seccionesDemo[indiceSeccion].questions[indicePregunta],
        modoUsuario,
        idiomas: this.idiomas,
        idiomaNative: this.idiomaNative,
        catalogoIdiomasSurvey: this.catalogoIdiomasSurvey,
        answerType: this.tiposPreguntas[this.tipoPregSel],
        columns: this.jsonCuestionario.columns,
        catalogoRespReactivos: this.catalogoRespReactivos,
        jsonCustomAbiertas: catalogos.jsonCustomAbiertas,
        pregCat: this.catalogoDemo[this.catalogoDemo.findIndex(item => item.idUnique == this.seccionesDemo[indiceSeccion].questions[indicePregunta].idUnique)],
        pasoCompleto: this.pasoCompleto,
        catalogoDemograficos: this.catalogoDemograficos,
        configTemplate: this.configTemplate,
        validationUser: this.validationUser
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("preguntaMod:",result);
      if(result.borraPreguntaMC){
        let indiceUnique = this.idsUniqueOcupadas.indexOf(result.idUnique);
        if(indiceUnique != -1){
          this.idsUniqueOcupadas.splice(indiceUnique,1);
          let indicePregCat = this.catalogoDemo.findIndex(item => item.idUnique == result.idUnique);
          if(indicePregCat != -1){
            this.catalogoDemo.splice(indicePregCat,1);
          }
        }
        this.seccionesDemo[indiceSeccion].questions.splice(indicePregunta,1);
        this.actualizaCuestionario();
      }
      else{
        if(result.preguntaActualizadaMC){
          let indicePregCat = this.catalogoDemo.findIndex(item => item.idUnique == result.preguntaActualizadaMC.idUnique);
          if(indicePregCat != -1){
            this.catalogoDemo[indicePregCat] = result.preguntaActualizadaMC;
          }
        }
        if(result.preguntaNuevaMC){
          this.catalogoDemo.push(result.preguntaNuevaMC);
          this.idsUniqueOcupadas.push(result.preguntaNuevaMC.idUnique);
        }
        switch (this.tipoSeccionActualizar) {
          case 1: this.accionText='editPregNps'; break;
          case 2: this.accionText='editPregReacti'; break;
          case 3: this.accionText='editPregControl'; break;
          case 4: this.accionText='editPregDemogra'; break;
          case 5: this.accionText='editPregAbier'; break;
          case 7: this.accionText='editPregAdici'; break;
          default: break;
        }
        //REESCRIBE EL VALUE ORDENADO A TODAS LAS RESPUESTAS
        result.pregunta.answers.forEach((respuesta, i) => {
          respuesta.value = (i + 1).toString();
        });
        this.seccionesDemo[indiceSeccion].questions[indicePregunta] = result.pregunta;
        this.actualizaCuestionario();
      }
    });
  }

  setSeccionEspecial(datosSeccion:any){
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '50%',
      disableClose: true,
      data: {
        opcion: 'seccionEspecial',
        idiomas: this.idiomas,
        datosSeccion,
        pasoCompleto: this.pasoCompleto
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        this.actualizaCuestionario();
      }
    });
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    this.templateGuardado = false;
    this.actualizaCuestionario();
  }

  dropPregunta(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }
    this.templateGuardado = false;
    this.actualizaCuestionario();
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

}
